import {script as listTips} from './../list-tips/list-tips';
import timing from './../../../design-system/motion/timing';
import $ from 'jquery';
import style from './list-zoom.scss';
import image from './list-zoom.jpg';
import imageEquipmentDesktop from './list-zoom-equipment_desktop.jpg';
import imageEquipmentTablet from './list-zoom-equipment_tablet.jpg';
import imageEquipmentMobile from './list-zoom-equipment_mobile.jpg';

const script = () => {
  const cssClass: string = 'ListZoom';
  const target: string = `.${cssClass}`;
  const targets: any = document.querySelectorAll(target);

  const percentPos = (pos:number, dim:number) => {
    return 100 * pos / dim;
  }
  const ratio = (width:number, height:number) => {
    return width / height;
  }

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      return true; // already init go to next iteration
    }

    // init element
    elt.dataset[`init${cssClass}`] = true;

    const btns = elt.querySelectorAll('.ListKeyPoints-list > li');
    const picture = elt.querySelector(`.${cssClass}-pictureZoom`);
    const description = document.createElement('div');
    description.classList.add(`${cssClass}-description`);
    elt.appendChild(description);

    const loader = document.createElement('span');
    loader.classList.add('AjaxLoader');
    picture.appendChild(loader);

    if(picture === null) {
      continue;
    }
    interface IDatas {
      posX?: number;
      posY?: number;
      zoom?: number,
      percentLeft?: number;
      percentTop?: number;
    }
    const datasDefault: IDatas = {
      percentLeft: 50,
      percentTop: 50,
      zoom: 1,
    }
    let datas:IDatas = {};
    let imgRatio:number;
    let pictureRatio:number;
    const setPosition = () => {
      if(datas.posX && datas.posY) {
        datas.percentLeft = percentPos(datas.posX,imgload.width);
        datas.percentTop = percentPos(datas.posY,imgload.height);
      }
      img.data.zoomed.width = datas.zoom * img.data.overflowed.width;
      img.data.zoomed.height = datas.zoom * img.data.overflowed.height;
      img.data.delta.left = datas.percentLeft * img.data.zoomed.width / 100 - picture.offsetWidth / 2;
      img.data.delta.right = (100 - datas.percentLeft) * img.data.zoomed.width / 100 - picture.offsetWidth / 2;
      img.data.delta.top = datas.percentTop * img.data.zoomed.height / 100 - picture.offsetHeight / 2;
      img.data.delta.bottom = (100 - datas.percentTop) * img.data.zoomed.height / 100 - picture.offsetHeight / 2;
      img.style.marginLeft = `${Math.min(img.data.delta.left, -1 * Math.min(img.data.delta.right, 0))}px`;
      img.style.marginTop = `${Math.min(img.data.delta.top,  -1 * Math.min(img.data.delta.bottom, 0))}px`;
      img.style.transformOrigin = `${datas.percentLeft}% ${datas.percentTop}%`;
      img.style.transform = `translate(-${datas.percentLeft}%, -${datas.percentTop}%) scale(${datas.zoom})`;
    }

    const testOverflow = () => {
      img.data = {
        overflowed: {},
        zoomed: {},
        delta: {},
      };
      if(imgRatio >= pictureRatio) {
        picture.classList.add('hasHorizontalOverflow');
        picture.classList.remove('hasVerticalOverflow');
        img.data.overflowed.width = picture.offsetHeight * imgRatio;
        img.data.overflowed.height = picture.offsetHeight;
      } else {
        picture.classList.remove('hasHorizontalOverflow');
        picture.classList.add('hasVerticalOverflow');
        img.data.overflowed.width = picture.offsetWidth;
        img.data.overflowed.height = picture.offsetWidth / imgRatio;
      }
    }

    const img = picture.querySelector('img');
    const imgload = new Image();
    imgload.onload = () => {
      imgLoaded();
    }
    imgload.src = img.dataset.src;
    const imgLoaded = () => {
      imgRatio = ratio(imgload.width, imgload.height);
      img.src = img.dataset.src;
      if(img.style.objectPosition && img.style.objectPosition.split('%').length - 1 === 2) {
        const objectPosition = img.style.objectPosition.split(' ').map((value:string) => parseFloat(value));
        datasDefault.percentLeft = objectPosition[0];
        datasDefault.percentTop = objectPosition[1];
      }
      datas = {...datasDefault};
      initButtons();

      window.addEventListener('resize', resizeWindow);
      resizeWindow();
      // addLoaded after first placement
      elt.classList.add('isLoaded');
      loader.remove();
    }

    const initButtons = () => {
      for (const [i,btn] of btns.entries()) {
        btn.addEventListener('click', ()=>{
          btn.classList.toggle('isActive');
          for (const [j,btnSiblings] of btns.entries()) {
            if(i !== j) { btnSiblings.classList.remove('isActive');
            }
          }
          $('html, body').animate({scrollTop: $(picture).offset().top}, timing.params['x-fast'], () => {
            if(btn.classList.contains('isActive')) {
              for(const [id,value] of Object.entries(btn.dataset)) {
                // @ts-ignore
                datas[id] = parseFloat(value);
              }
              const itemDescription = btn.querySelector(`.${cssClass}-itemDescription`);
              description.innerHTML = itemDescription.innerHTML;
              description.style.display = 'block';
              listTips();

            } else {
              delete datas.posX;
              delete datas.posY;
              datas = {...datasDefault};
              description.innerHTML = '';
              description.style.display = 'none';
            }
            setPosition();
            // avoid SiteHeader display on auto scroll top
            setTimeout(()=> {
              $('.SiteHeader').addClass('isScrollingDown');
            }, 10);
          });
        })
      }
    }
    const resizeWindow = () => {
      pictureRatio = ratio(picture.offsetWidth, picture.offsetHeight);
      testOverflow();
      setPosition();
    }
  }
};

export {
  style,
  script,
  image,
  imageEquipmentDesktop,
  imageEquipmentTablet,
  imageEquipmentMobile,
};
